import m0_6 from './0.6'
import m0_7 from './0.7'
import m0_8 from './0.8'
import m0_9 from './0.9'
import m1_0 from './1.0'
import m1_2 from './1.2'
import m1_3 from './1.3'
import m2020_3_4 from './2020.3.4'
import m2020_3_9 from './2020.3.9'
import m2020_3_16 from './2020.3.16'
import m2020_3_26 from './2020.3.26'
import m2020_4_3 from './2020.4.3'
import m2020_5_5 from './2020.5.5'
import m2020_6_12 from './2020.6.12'
import m2020_7_7 from './2020.7.7'
import m2020_8_28 from './2020.8.28'
import m2020_11_16 from './2020.11.16'
import m2021_1_15 from './2021.1.15'
import m2021_2_4 from './2021.2.4'
import m2021_2_8 from './2021.2.8'
import m2021_4_13 from './2021.4.13'
import m2021_6_9 from './2021.6.9'
import m2021_8_1 from './2021.8.1'
import m2022_5_17 from './2022.5.17'
import m2022_5_17_1 from './2022.5.17-1'
import m2023_1_7 from './2023.1.7'
import m2023_3_29 from './2023.3.29'
import m2023_8_15 from './2023.8.15'
import m2025_2_19 from './2025.2.19'
import m2025_11_27 from './2025.11.27'
import m2026_2_5 from './2026.2.5'
import m2026_4_13 from './2026.4.13'

export default {
  m0_6,
  m0_7,
  m0_8,
  m0_9,
  m1_0,
  m1_2,
  m1_3,
  m2020_3_4,
  m2020_3_9,
  m2020_3_16,
  m2020_3_26,
  m2020_4_3,
  m2020_5_5,
  m2020_6_12,
  m2020_7_7,
  m2020_8_28,
  m2020_11_16,
  m2021_1_15,
  m2021_2_4,
  m2021_2_8,
  m2021_4_13,
  m2021_6_9,
  m2021_8_1,
  m2022_5_17,
  m2022_5_17_1,
  m2023_1_7,
  m2023_3_29,
  m2023_8_15,
  m2025_2_19,
  m2025_11_27,
  m2026_2_5,
  m2026_4_13,
}
